import React, { FC } from 'react';
import ENV from '../../base/env';
import './PredictorWidget.scss';

export interface IPredictorWidgetProps {
  customClass?: string;
  title: string;
  description: string;
}

export const PredictorWidget: FC<React.PropsWithChildren<IPredictorWidgetProps>> = ({
  title,
  description,
  customClass,
  children,
}) => {
  const iconSrc = `${ENV.AssetsBaseUrl}/feature/success-predictor/thumbs-up.svg`;
  const containerClass = customClass ? `success-predictor ${customClass}` : 'success-predictor';
  return (
    <div className={containerClass}>
      <div className="predictor-icon">
        <img data-testid="sp-icon" src={iconSrc} alt={title} />
      </div>
      <div className="predictor-content">
        <p className="predictor-title">{title}</p>
        <p className="predictor-description">{description}</p>
      </div>
      {children}
    </div>
  );
};
export default PredictorWidget;
